module.exports = __webpack_public_path__ + "img/400.87ae7692.png";